import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import InstagramAdd from './pages/InstagramAdd';
import PostInstagram from './pages/postInstagram';
import Home from './pages/Home';
import Instagram from './pages/Instagram';
import Test from './pages/test';
const router = createBrowserRouter([
  {
    path: "/",
    element: <App/>,
    children: [
      {
        path: "insta-add",
        element: <InstagramAdd/>,
      },
      {
        path: "post-instagram",
        element: <PostInstagram/>,
      },
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/instagram",
        element: <Instagram />,
      },
      {
        path: "/test",
        element: <Test />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
